// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wpKzoJ6XJ7rz7HqzTsPx{margin:0 32px;box-sizing:border-box}.wpKzoJ6XJ7rz7HqzTsPx .ZXOoPiakEv6_ZdTGAxen .ag-popup{position:static}.Bllth07seFfYazgYZVYW{padding:0}.Bllth07seFfYazgYZVYW svg{color:#eb958f}.Bllth07seFfYazgYZVYW:hover svg{color:#dd4e44}`, "",{"version":3,"sources":["webpack://./src/Pages/decision-log/projects/styles.styl"],"names":[],"mappings":"AAEA,sBACI,aAAO,CACP,qBAAW,CAGP,sDACI,eAAS,CAErB,sBACI,SAAQ,CAER,0BACI,aAAM,CAGN,gCACI,aAAM","sourcesContent":["@import '~assets/stylus/config/colors'\n\n.container\n    margin 0 32px\n    box-sizing border-box\n\n    .gridContainer\n        :global(.ag-popup)\n            position static\n\n.deleteButton\n    padding 0\n\n    svg\n        color lighten(colorRed, 40%);\n\n    &:hover\n        svg\n            color colorRed\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textColor": `#404041`,
	"colorRed": `#dd4e44`,
	"colorPink": `#ff1493`,
	"colorBlue": `#24b2e0`,
	"colorGreen": `#65c178`,
	"colorOrange": `#fa9961`,
	"colorYellow": `#e09f34`,
	"colorPurple": `#5841ab`,
	"colorDarkBlue": `#223c75`,
	"colorBrightBlue": `#3398d9`,
	"colorGoogle": `#4285f4`,
	"container": `wpKzoJ6XJ7rz7HqzTsPx`,
	"gridContainer": `ZXOoPiakEv6_ZdTGAxen`,
	"deleteButton": `Bllth07seFfYazgYZVYW`
};
export default ___CSS_LOADER_EXPORT___;
